/* NESW-ROW-JS-EXTERNAL-V1 — extracted 2026-07-29 from sections/nesw-collection-row.liquid (was inlined 3x on the homepage = 69KB duplicate bytes). Loaded once, cached, deferred. Run-once guards (__neswArrowsBound, __neswRowCardJsLoaded) unchanged. */
(function () {
  /* Arrow scrolling — per-row binding */
  document.querySelectorAll('.nesw-row__scroller').forEach(function (row) {
    var track = row.querySelector('[data-track]');
    if (!track || track.__neswArrowsBound) return;
    track.__neswArrowsBound = true;
    var prev = row.querySelector('.nesw-row__nav--prev');
    var next = row.querySelector('.nesw-row__nav--next');
    function step() {
      var card = track.querySelector('.nesw-row__card-wrap');
      return card ? (card.offsetWidth + 14) * 2 : 320;
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* Guard so multiple rows on a page don't double-bind the document listeners. */
  if (window.__neswRowCardJsLoaded) return;
  window.__neswRowCardJsLoaded = true;

  /* Mobile row order is now authored directly in templates/index.json. The
     JS reorder that used to live here was the homepage's main CLS source
     (2026-09-01 trace diagnosis) and its target row (row_shop_all) no longer exists. */

  /* V2 — Mobile tap guard (re-enabled, tuned).
     Why this exists: the home rows are `.nesw-row__track` horizontal
     scrollers, and each card is an `<a>`. When the user vertically
     scrolls the page their finger lands inside the carousel, and
     mobile browsers misfire taps on the card because they have to
     pick between three axes (page Y, track X, tap). The collection
     page has no nested scroller so it never has this problem.

     A previous strict guard was too aggressive (blocked legit taps).
     This version uses a single, lenient rule: if the finger moved
     more than ~12px during the touch, or the page/track scrolled at
     all, suppress the next click. Real taps move <5px in practice —
     12px is comfortable headroom and still catches every drag.

     Captures the click in the capture phase so it blocks navigation
     before the `<a>` follows the href. */
  var __touchStartX = null;
  var __touchStartY = null;
  var __touchMaxDist = 0;
  var __touchStartTime = null;
  var __touchStartTrack = null;
  var __touchStartTrackScrollLeft = null;
  var __touchStartScrollTop = 0;
  var __scrollFiredDuringTouch = false;
  /* Tightened 12 -> 8px: home cards were still too easy to trigger while
     scrolling (vs the collection page, which has no nested scroller and
     leans on the browser's native tap/scroll discrimination). Real taps
     move <5px, so 8px is safe headroom but cancels more drift-taps. */
  var __MOVE_THRESHOLD_PX = 8;

  /* 🔴 The page scrolls via <body> on this theme (body.scrollTop is the live
     position; window.pageYOffset / documentElement.scrollTop stay 0). Read all
     three so the guard is correct wherever the scroller actually is. The
     position DELTA (touchstart → click) is the most reliable "did the page
     scroll" signal — immune to scroll-event timing, momentum, and the nested
     horizontal track that makes native tap/scroll discrimination unreliable
     here (the collection page has no nested scroller, which is why it already
     feels right). */
  function __pageScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }

  var __lastScrollTime = 0;
  var __recentScrollAtStart = false;
  var __wasGlidingAtStart = false;
  function __noteScroll() {
    __lastScrollTime = Date.now();
    if (__touchStartTime !== null) __scrollFiredDuringTouch = true;
    /* A real scroll (incl. momentum glide, which still fires 'scroll' events
       except right at the moment a finger lands again) is exactly when the
       motion-RAF sampler below needs to be alive. Restarts it if idled out. */
    __startMotionRAF();
  }
  /* capture:true — this theme scrolls via <body>, so the scroll event fires on
     body, not window; capture lets us hear it. */
  window.addEventListener('scroll', __noteScroll, { capture: true, passive: true });
  function __bindTrackScroll() {
    document.querySelectorAll('.nesw-row__track').forEach(function (t) {
      if (t.__neswScrollBound) return;
      t.__neswScrollBound = true;
      t.addEventListener('scroll', __noteScroll, { passive: true });
    });
  }
  __bindTrackScroll();
  window.addEventListener('load', __bindTrackScroll);

  /* 🔴 rAF motion tracker — the decisive signal for "tap to STOP a momentum
     scroll." iOS throttles/skips 'scroll' events during inertial scrolling, so
     a finger that lands to halt the glide may not see a recent scroll EVENT.
     Polling scrollTop every frame catches the motion regardless: any change =
     the page is (still) moving, so the tap that stops it is treated as a scroll,
     not a navigation. Updates __lastScrollTime (feeds __recentScrollAtStart +
     __scrollTail) and, if a touch is in progress, the during-touch flag. */
  /* 🔴 Gated 2026-09-01 (was an unconditional forever-loop — ~60fps main-thread
     tax on every page load, confirmed via trace). Now only runs while a touch
     or scroll gesture could still be gliding: started by touchstart/scroll,
     and stops rescheduling after 2s with no fresh activity. The next
     touchstart or scroll restarts it; __motionRAFActive guards against
     double-starting two concurrent loops. */
  var __rafPrevTop = __pageScrollTop();
  var __motionRAFActive = false;
  var __motionRAFLastActivity = 0;
  function __motionRAF() {
    var t = __pageScrollTop();
    if (t !== __rafPrevTop) {
      __rafPrevTop = t;
      __lastScrollTime = Date.now();
      /* Detected motion counts as activity: iOS momentum glides can deliver
         scroll EVENTS >450ms apart while the page is still visibly moving —
         without this the sampler idled mid-glide and a later tap read a
         stale __rafPrevTop, swallowing the tap (Fable wave-3 review). */
      __motionRAFLastActivity = __lastScrollTime;
      if (__touchStartTime !== null) __scrollFiredDuringTouch = true;
    }
    /* 🔴 Idle cutoff: was 2000ms (confirmed an unconditional ~60fps tax before
       the 2026-09-01 gating, then a 2s-after-idle tax even gated — measured
       224ms of 500ms main-thread busy time in self-time here alone over a 7s
       scroll session, w3-3-inp.json). Every consumer of the timestamps this
       loop feeds (__recentScrollAtStart, __scrollTail) only ever checks
       freshness within 180-450ms, so nothing downstream can tell the
       difference between stopping at 2000ms and stopping at 450ms — 450 is
       the largest window any consumer reads, kept as the cutoff rather than
       going tighter. */
    if (Date.now() - __motionRAFLastActivity > 450) {
      __motionRAFActive = false;
      return;
    }
    requestAnimationFrame(__motionRAF);
  }
  function __startMotionRAF() {
    __motionRAFLastActivity = Date.now();
    if (__motionRAFActive) return;
    __motionRAFActive = true;
    requestAnimationFrame(__motionRAF);
  }

  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest || !e.target.closest('.nesw-row__card-wrap')) return;
    if (!e.touches || !e.touches[0]) return;
    __startMotionRAF();
    __touchStartX = e.touches[0].clientX;
    __touchStartY = e.touches[0].clientY;
    __touchMaxDist = 0;
    __touchStartTime = Date.now();
    __touchStartTrack = e.target.closest('.nesw-row__track');
    __touchStartTrackScrollLeft = __touchStartTrack ? __touchStartTrack.scrollLeft : null;
    __touchStartScrollTop = __pageScrollTop();
    __scrollFiredDuringTouch = false;
    /* Did this tap start while the page was still gliding from a scroll?
       (touching stops iOS momentum, so we won't see a scroll DURING the touch —
       we have to look at how recently one fired.) Widened to 450ms. */
    __recentScrollAtStart = (Date.now() - __lastScrollTime) < 450;
    /* 🔴 THE iOS MOMENTUM FIX: during inertial scrolling iOS THROTTLES both
       scroll events AND requestAnimationFrame, so __lastScrollTime/the rAF
       sampler go stale and the checks above miss a "tap to stop the glide."
       But the page HAS moved since the last rAF frame — so if the live scroll
       position differs from the last sampled position, the page was gliding
       when the finger landed. This catches the stop-tap even when every
       event/rAF was paused. */
    __wasGlidingAtStart = Math.abs(__touchStartScrollTop - __rafPrevTop) > 2;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (__touchStartTime === null || !e.touches || !e.touches[0]) return;
    var dx = e.touches[0].clientX - __touchStartX;
    var dy = e.touches[0].clientY - __touchStartY;
    var d = Math.sqrt(dx * dx + dy * dy);
    if (d > __touchMaxDist) __touchMaxDist = d;
  }, { passive: true });

  /* Capture-phase so we beat the `<a>` navigation. preventDefault on
     a click event on an `<a>` cancels the navigation in every modern
     browser. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var card = e.target.closest('.nesw-row__card');
    if (!card) {
      __touchStartTime = null;
      __scrollFiredDuringTouch = false;
      __touchMaxDist = 0;
      return;
    }
    /* Allow clicks on interactive descendants (quick-add, swatches,
       bookmark) — those have their own handlers that already call
       stopPropagation/preventDefault as needed. The guard only
       applies to bare navigation on the card itself. */
    if (e.target.closest('.quick-add-btn, .color-swatch, .nesw-bookmark, .related-size-btn, button')) {
      __touchStartTime = null;
      __scrollFiredDuringTouch = false;
      __touchMaxDist = 0;
      return;
    }
    /* Was this click backed by a touch that drifted, or did the page/track
       scroll during the touch? If yes, treat it as an accidental tap during a
       scroll gesture and cancel navigation. Signals (any → cancel):
         • finger drifted past the move threshold
         • a scroll event fired DURING the touch
         • the page actually MOVED (scrollTop delta) — bulletproof, immune to
           event timing/momentum; this is the main fix for slow scrolls
         • the horizontal track actually moved (scrollLeft delta)
         • a scroll fired right before the touch started (tapping mid-glide)
         • a scroll fired right before THIS click (tapping the scroll's tail)
         • a long press that also drifted (a slow drag-to-scroll, not a tap) */
    if (__touchStartTime !== null) {
      var __scrollDelta = Math.abs(__pageScrollTop() - __touchStartScrollTop);
      var __trackDelta = (__touchStartTrack && __touchStartTrackScrollLeft !== null)
        ? Math.abs(__touchStartTrack.scrollLeft - __touchStartTrackScrollLeft) : 0;
      var __scrollTail = (Date.now() - __lastScrollTime) < 180;
      var __dur = Date.now() - __touchStartTime;
      /* Also re-check the glide signal at click time: if the live position
         still differs from the last rAF sample, the page is/was moving. */
      var __glideNow = Math.abs(__pageScrollTop() - __rafPrevTop) > 2;
      if (__touchMaxDist > __MOVE_THRESHOLD_PX ||
          __scrollFiredDuringTouch ||
          __scrollDelta > 2 ||
          __trackDelta > 2 ||
          __recentScrollAtStart ||
          __scrollTail ||
          __wasGlidingAtStart ||
          __glideNow ||
          (__dur > 500 && __touchMaxDist > 3)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
    __touchStartTime = null;
    __scrollFiredDuringTouch = false;
    __touchMaxDist = 0;
    __recentScrollAtStart = false;
    __wasGlidingAtStart = false;
  }, true);

  document.addEventListener('touchend', function () {
    /* Click fires synchronously after touchend; reset happens in
       the click handler above. */
  }, { passive: true });

  /* Hover image flip is now pure CSS (`.product-image--hover` + `:hover`,
     see the <style> block) — no JS needed, matching the collection page. */

  /* NESW-FLIP-NOGHOST-2026-07-27 — preload a color's front + back the moment
     the pointer touches its swatch, so by click time both images are cached
     and the swap paints instantly (no old-variant lingering). Once per swatch. */
  document.addEventListener('mouseover', function (e) {
    if (!e.target || !e.target.closest) return;
    var sw = e.target.closest('.nesw-row .color-swatch');
    if (!sw || sw.__neswPre) return;
    sw.__neswPre = true;
    [sw.dataset.variantImage, sw.dataset.variantImage2].forEach(function (u) {
      if (u) { var im = new Image(); im.src = u; }
    });
  }, { passive: true });

  /* Swatch click — swap card image + active state, scoped to .nesw-row */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var swatch = e.target.closest('.nesw-row .color-swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();

    var item = swatch.closest('.collection-item');
    if (!item) return;
    var container = swatch.closest('.color-swatches');
    if (container) {
      container.querySelectorAll('.color-swatch').forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');
    }
    var info = item.querySelector('.current-color-name');
    if (info) info.textContent = swatch.dataset.color || info.textContent;

    var variantImage = swatch.dataset.variantImage;
    var variantImageLarge = swatch.dataset.variantImageLarge;
    var variantImage2 = swatch.dataset.variantImage2;
    var variantImage2Large = swatch.dataset.variantImage2Large;
    if (variantImage) {
      /* NESW-CARD-COLORFLIP-2026-07-27 — primary image = the selected color's
         featured shot; hover-flip image = that color's SECOND shot (its back),
         or the primary again when the color has only one image. This keeps the
         hover flip working WITHIN the selected color instead of getting stuck
         (both images had been overwritten with the same src) or revealing the
         original color's back. */
      var primaryImg = item.querySelector('img.product-image:not(.product-image--hover)');
      var hoverImg = item.querySelector('img.product-image--hover');
      if (primaryImg) {
        primaryImg.src = variantImage;
        if (variantImageLarge) primaryImg.srcset = variantImage + ' 800w, ' + variantImageLarge + ' 2048w';
      }
      if (hoverImg) {
        var hoverSrc = variantImage2 || variantImage;
        var hoverLarge = variantImage2 ? variantImage2Large : variantImageLarge;
        /* NESW-FLIP-NOGHOST-2026-07-27 — hide the hover layer until the new
           back image has DECODED. Just setting .src keeps the previously
           painted image (the OLD color's back) on screen until the new file
           arrives, so a quick hover right after a swatch click flashed the
           previous variant. Inline opacity:0 beats the CSS :hover reveal, and
           while hidden the card simply shows the new primary underneath. */
        if (hoverImg.src !== hoverSrc) {
          hoverImg.style.opacity = '0';
          var clearGuard = function () {
            hoverImg.style.opacity = '';
            hoverImg.removeEventListener('load', clearGuard);
            hoverImg.removeEventListener('error', clearGuard);
          };
          hoverImg.addEventListener('load', clearGuard);
          hoverImg.addEventListener('error', clearGuard);
        }
        hoverImg.src = hoverSrc;
        if (hoverLarge) hoverImg.srcset = hoverSrc + ' 800w, ' + hoverLarge + ' 2048w';
        /* Cached image: load may not re-fire — clear the guard immediately. */
        if (hoverImg.complete && hoverImg.naturalWidth > 0) hoverImg.style.opacity = '';
      }
    }

    var pid = swatch.dataset.productId;
    if (pid) {
      /* Scoped to this swatch's own row, not `document`. A homepage with N
         rows re-queried and re-matched EVERY quick-add-wrapper on the page on
         every swatch tap; scoping to the row this swatch lives in is
         equivalent whenever a product isn't duplicated across two different
         rows on the same page (the one case this narrows: two on-screen
         copies of the same product no longer sync a swatch pick between
         them — check the homepage merchandising before adding a duplicate
         listing across rows). */
      var __swatchRow = swatch.closest('.nesw-row') || document;
      __swatchRow.querySelectorAll('.quick-add-wrapper[data-product-id="' + pid + '"]').forEach(function (w) {
        w.dataset.selectedColor = swatch.dataset.color || '';
        /* V2 — Carry the swatch's variant image onto the wrapper so the
           bottom-sheet quick-add drawer (`snippets/nesw-row-quickadd-drawer.liquid`)
           can render the picked color's hero photo. Previously the
           drawer's `populate()` always used `btn.dataset.productImage`
           which is the product's default image, so picking a secondary
           color and opening the drawer showed the wrong shot. */
        if (swatch.dataset.variantImage) {
          w.dataset.selectedColorImage = swatch.dataset.variantImage;
        }
        /* Repaint the size buttons for the newly-selected color. */
        refreshSizes(w);
      });
    }
    /* A colour can carry its own price, so the card reprices on swatch clicks
       as well as pack clicks. No-ops on the single-price products. */
    repriceCard(item);

    /* Rebind the card's bookmark to the newly-selected color so the
       saved indicator reflects "is THIS color saved?" rather than
       "is the product saved?" (the bookmark used to stay highlighted
       no matter which swatch was clicked). */
    var bookmark = item.querySelector('.nesw-bookmark');
    if (bookmark) {
      var newColor = swatch.dataset.color || '';
      bookmark.setAttribute('data-bookmark-color', newColor);
      if (variantImage) bookmark.setAttribute('data-bookmark-image', variantImage);
      /* variantId stays empty on home/collection rows — these are
         color-only saves. The wishlist store's composite key uses the
         color as the differentiator when variantId is empty. */
      bookmark.setAttribute('data-bookmark-variant-id', '');
      var bhandle = bookmark.getAttribute('data-bookmark-handle');
      if (bhandle && newColor) {
        bookmark.setAttribute('data-bookmark-url',
          '/products/' + bhandle + '?color=' + encodeURIComponent(newColor));
      }
      if (window.NESWWishlist && typeof window.NESWWishlist.sync === 'function') {
        window.NESWWishlist.sync();
      }
    }
  }, true);

  /* ---- Third axis (today: Pack Size) + per-variant card pricing ----
     The card used to render product.price, which is Shopify's LOWEST variant
     price, so a product spanning two price points advertised the cheaper one
     whatever the shopper picked — the tee bundle showed the 3-Pack's $81 while
     its 4-Pack is $102.40. Selecting a chip now reprices the card from the
     variant matrix (Jay 2026-08-31). */

  function __neswCardOf(el) {
    return el.closest('.nesw-row__card-wrap, .collection-item, .nesw-row__card');
  }
  /* The variant matrix lives on .quick-add-sizes; it is the only payload that
     carries price and the extra axis (a superset of the quick-add-btn
     payload refreshSizes used to parse separately — same id/size/color/
     available fields, plus extra/price/compare/cents).
     Parsed once per card and cached on card.__neswVariants: this JSON is
     rendered once at SSR and nothing on the page ever rewrites it, so there
     is no invalidation case — every swatch/pack tap on the same card was
     re-parsing an identical ~1-2KB (up to 19KB on the biggest card) payload
     from scratch (measured: 34 data-variants attributes / 84,042 chars on
     the homepage, parsed TWICE per tap before this change — once here, once
     more in refreshSizes — w3-3-inp.json). Shared by both repriceCard and
     refreshSizes below. */
  function __neswCardVariants(card) {
    if (!card) return [];
    if (card.__neswVariants) return card.__neswVariants;
    var host = card.querySelector('.quick-add-sizes');
    if (!host) return [];
    var parsed;
    try { parsed = JSON.parse(host.getAttribute('data-variants') || '[]'); } catch (_) { parsed = []; }
    card.__neswVariants = parsed;
    return parsed;
  }
  function __neswSelectedColor(card) {
    var sw = card && card.querySelector('.color-swatch.active');
    if (sw) return (sw.dataset.color || '').trim();
    var wrap = card && card.querySelector('.quick-add-wrapper');
    return ((wrap && wrap.dataset.selectedColor) || '').trim();
  }
  function __neswSelectedExtra(card) {
    var chip = card && card.querySelector('.pack-btn.active');
    return chip ? (chip.dataset.extra || '').trim() : '';
  }
  /* Reprice from the CHEAPEST variant matching the current selection. Size does
     not usually move the price, so collapsing across sizes is right; when it
     does, the lowest is the honest headline for a card. */
  function repriceCard(card) {
    if (!card) return;
    var priceEl = card.querySelector('.nesw-row__price[data-repriceable]');
    if (!priceEl) return;                 /* sale branch renders its own markup */
    var variants = __neswCardVariants(card);
    if (!variants.length) return;
    var colour = __neswSelectedColor(card);
    var extra = __neswSelectedExtra(card);
    var pool = variants.filter(function (v) {
      if (extra && (v.extra || '') !== extra) return false;
      if (colour && (v.color || '') !== colour) return false;
      return true;
    });
    /* A colour that does not exist in the chosen pack must not blank the price;
       fall back to the pack alone, then to everything. */
    if (!pool.length && extra) pool = variants.filter(function (v) { return (v.extra || '') === extra; });
    if (!pool.length) pool = variants;
    var best = null;
    pool.forEach(function (v) {
      var c = typeof v.cents === 'number' ? v.cents : Infinity;
      if (!best || c < best.cents) best = { cents: c, price: v.price, compare: v.compare };
    });
    if (!best || !best.price) return;
    /* Built as DOM, not innerHTML: these strings come from the shop's
       money_format, which is a merchant-editable setting rather than a number.
       Nothing here needs HTML, so nothing here parses HTML. Structure mirrors
       the server-rendered markup exactly (<del>was</del> then the price). */
    while (priceEl.firstChild) priceEl.removeChild(priceEl.firstChild);
    if (best.compare) {
      var del = document.createElement('del');
      del.textContent = best.compare;
      priceEl.appendChild(del);
      priceEl.appendChild(document.createTextNode(' '));
    }
    priceEl.appendChild(document.createTextNode(best.price));
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var chip = e.target.closest('.nesw-row .pack-btn');
    if (!chip) return;
    /* Sibling-listing SWAP chips (data-swap) belong to nesw-pack-swap.js —
       this handler runs FIRST (earlier registration) and its active-class
       set was making the swap handler think the chip was already current,
       skipping the whole swap (found 2026-09-04). */
    if (chip.hasAttribute('data-swap')) return;
    /* The chips sit inside the card's <a>; without this the click navigates. */
    e.preventDefault();
    e.stopPropagation();
    var card = __neswCardOf(chip);
    if (!card) return;
    card.querySelectorAll('.pack-btn').forEach(function (b) { b.classList.remove('active'); });
    chip.classList.add('active');
    card.querySelectorAll('.quick-add-wrapper').forEach(function (w) {
      w.dataset.selectedExtra = chip.dataset.extra || '';
      refreshSizes(w);
    });
    repriceCard(card);
    /* Sheet header price follows the chosen pack too (2026-09-04): the
       quick-add reads data-product-price, which otherwise kept quoting the
       old pack. Cheapest variant matching the pick, like repriceCard. */
    var __epQab = card.querySelector('.quick-add-btn');
    if (__epQab) {
      var __epVars = [];
      try { __epVars = JSON.parse(__epQab.dataset.variants || '[]'); } catch (_) {}
      var __epBest = null;
      __epVars.forEach(function (v) {
        if ((v.extra || '') !== (chip.dataset.extra || '')) return;
        var c = typeof v.cents === 'number' ? v.cents : Infinity;
        if (!__epBest || c < __epBest.cents) __epBest = v;
      });
      if (__epBest && __epBest.price) {
        __epQab.dataset.productPrice = __epBest.price;
        __epQab.removeAttribute('data-product-price-html');
      }
    }
  }, true);

  /* Quick-add — rebuild visible size buttons from variants JSON. */
  function refreshSizes(wrapper) {
    var sel = wrapper.dataset.selectedColor;
    /* On initial render no swatch click has set selectedColor — fall back to the
       default-active swatch so sold-out sizes reflect the shown color, not an
       aggregate across colors. */
    if (!sel) {
      var __c = wrapper.closest('.collection-item, .nesw-row__card');
      var __sw = __c && __c.querySelector('.color-swatch.active');
      if (__sw) sel = (__sw.dataset.color || '').trim();
    }
    var btn = wrapper.querySelector('.quick-add-btn');
    var sizes = wrapper.querySelector('.quick-add-sizes');
    if (!btn || !sizes) return;
    /* Shares the same cached-per-card matrix as repriceCard (__neswCardVariants
       above) instead of parsing btn.dataset.variants as a second, separate
       payload — that second parse duplicated ~half the homepage's swatch-tap
       JSON cost (w3-3-inp.json). The quick-add-sizes payload is a superset of
       every field this function reads (id/size/color/available), so nothing
       here changes what gets rendered. */
    var __szCard = __neswCardOf(wrapper) || wrapper.closest('.nesw-row__card-wrap, .collection-item, .nesw-row__card');
    var variants = __neswCardVariants(__szCard);
    if (!variants.length) return;
    /* Narrow by the third axis too, or a 3-Pack shows sizes that only exist in
       the 4-Pack. Applied before the colour filter so the fallbacks below still
       mean what they say. */
    var extraSel = (wrapper.dataset.selectedExtra || '').trim();
    if (!extraSel) {
      var __card0 = wrapper.closest('.nesw-row__card-wrap, .collection-item, .nesw-row__card');
      var __chip = __card0 && __card0.querySelector('.pack-btn.active');
      if (__chip) extraSel = (__chip.dataset.extra || '').trim();
    }
    if (extraSel) {
      var byExtra = variants.filter(function (v) { return (v.extra || '') === extraSel; });
      if (byExtra.length) variants = byExtra;
    }
    var filtered = sel ? variants.filter(function (v) { return v.color === sel; }) : variants;
    if (!filtered.length) filtered = variants;
    /* When no color is picked, "available" reflects aggregate stock
       across colors (in stock if any color has this size). With a color
       picked, it reflects that specific color. Mirrors the Liquid
       initial-render logic so bundle/pack products no longer show every
       size as available based on the variety variant alone. */
    var aggregateAvail = Object.create(null);
    if (!sel) {
      variants.forEach(function (v) { if (v.available) aggregateAvail[v.size] = true; });
    }
    var seen = Object.create(null);
    while (sizes.firstChild) sizes.removeChild(sizes.firstChild);
    filtered.forEach(function (v) {
      if (seen[v.size]) return;
      seen[v.size] = true;
      var inStock = sel ? !!v.available : !!aggregateAvail[v.size];
      var b = document.createElement('button');
      b.className = 'size-btn' + (inStock ? '' : ' size-btn-disabled');
      b.dataset.variantId = v.id;
      b.dataset.size = v.size;
      b.dataset.productId = btn.dataset.productId;
      b.disabled = !inStock;
      b.textContent = v.size;
      sizes.appendChild(b);
    });
    /* Single-size product (hats, one-size accessories): swap the
       label from the literal size value ("One Size") to a clearer
       call-to-action so the shopper doesn't think they still need to
       pick a size. */
    if (sizes.children.length === 1) {
      var only = sizes.children[0];
      only.classList.add('size-btn--single');
      only.textContent = 'Add to Cart';
    }
  }

  /* Desktop hover is handled by CSS (`:hover .quick-add-sizes`). The
     Liquid-rendered size buttons are the source of truth; we don't
     rebuild them during hover — `refreshSizes` only runs when a color
     swatch is clicked, so the visible sizes stay stable while the user
     reads across them. */

  /* Quick-add button click — toggle sticky drawer */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var qb = e.target.closest('.nesw-row .quick-add-btn');
    if (!qb) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = qb.closest('.quick-add-wrapper');
    if (!wrap) return;
    refreshSizes(wrap);
    var sizes = wrap.querySelector('.quick-add-sizes');
    if (!sizes) return;
    sizes.classList.toggle('show-sizes-sticky');
  });

  /* Click outside closes sticky drawers */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.nesw-row .quick-add-wrapper')) return;
    document.querySelectorAll('.nesw-row .quick-add-sizes.show-sizes-sticky').forEach(function (el) {
      el.classList.remove('show-sizes-sticky');
    });
  });

  /* V2 — Resolve (activeColor, size) → correct variant id from the
     size container's data-variants matrix. Falls back to the size
     pill's baked-in id if no active swatch or no matrix. */
  function __neswRowResolveVariantId(sb) {
    var fallback = sb.dataset.variantId;
    var wrap = sb.closest('.quick-add-wrapper');
    if (!wrap) return fallback;
    var activeSwatch = wrap.parentElement && wrap.parentElement.querySelector('.color-swatch.active, .product-color-swatch.w--ecommerce-pill-selected');
    /* Fall back to selectedColor dataset on the wrapper (set by the
       row's own swatch-click handler). */
    var activeColor = (activeSwatch && (activeSwatch.dataset.color || '').trim()) ||
                      (wrap.dataset.selectedColor || '').trim();
    if (!activeColor) return fallback;
    var sizes = sb.closest('.quick-add-sizes');
    var raw = sizes && sizes.getAttribute('data-variants');
    if (!raw) return fallback;
    var sizeLabel = (sb.dataset.size || sb.textContent || '').toString().trim();
    try {
      var variants = JSON.parse(raw);
      /* 🔴 Match the THIRD axis as well, or a size click on a 3-Pack could add
         the 4-Pack's variant — the two differ by $21.40. Only constrains when
         the product actually has one. */
      var card = sb.closest('.nesw-row__card-wrap, .collection-item, .nesw-row__card');
      var chip = card && card.querySelector('.pack-btn.active');
      var activeExtra = chip ? (chip.dataset.extra || '').trim() : '';
      var match = variants.find(function (v) {
        if (activeExtra && (v.extra || '').toString().trim() !== activeExtra) return false;
        return (v.color || '').toString().trim() === activeColor &&
               (v.size || '').toString().trim() === sizeLabel;
      });
      if (match && match.id) return String(match.id);
    } catch (_) {}
    return fallback;
  }

  /* Size click — matches the collection-page addToCart flow exactly. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var sb = e.target.closest('.nesw-row .size-btn');
    if (!sb || sb.disabled || sb.classList.contains('size-btn-disabled')) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = __neswRowResolveVariantId(sb);
    if (!variantId) return;

    var originalContent = sb.innerHTML;
    sb.classList.add('adding');
    sb.textContent = 'Adding...';

    window.neswAddToCart(variantId, 1, { openDrawer: true })
      .then(function (cart) {
        sb.classList.remove('adding');
        sb.classList.add('added');
        sb.textContent = 'Added!';
        /* Pass the cart neswAddToCart already resolved with (a fresh
           /cart.js it just fetched to reconcile) instead of calling the
           no-arg form, which would fire its own redundant /cart.js. */
        if (typeof window.updateCartCount === 'function') window.updateCartCount(cart);
        setTimeout(function () {
          sb.classList.remove('added');
          sb.innerHTML = originalContent;
        }, 1000);
      })
      .catch(function () {
        sb.classList.remove('adding');
        sb.innerHTML = originalContent;
        alert('Could not add to cart. Please try again.');
      });
  });
})();

/* Pack-size chips for sibling LISTINGS (tank 3-Pack <-> 6-Pack) live in
   assets/nesw-pack-swap.js since 2026-09-04: they swap the card in place
   (image/price/title/links/quick-add dataset) instead of navigating. */
